<script setup>
import CtaLink from "@/Pages/Info/Partials/CtaLink.vue";
import CtaSection from "@/Pages/Info/Partials/CtaSection.vue";

defineProps({
    acceptDemo: Boolean,
    demoUrl: String,
});
</script>

<template>
    <CtaSection v-if="acceptDemo">
        <template #cta> Want a closer look? Schedule a demo today. </template>
        <template #link>
            <CtaLink as="a" :href="demoUrl" target="_blank">
                Schedule Demo
            </CtaLink>
        </template>
    </CtaSection>
</template>
